import { AxiosError } from 'axios';
import { Formik } from 'formik';
import { applyDiscount } from '../../../../api/requests';
import Input from '../../../../components/form-control/Input';
import { IRequestResponse } from '../../../../resources/interfaces';
import * as Yup from 'yup';
import Button from '../../../../components/form-control/Button';
import { Policy } from '../../../../models/policy/Policy';
import { showToast } from '../../../../utils/miscFunctions';

type ApplyDiscountProps = {
  closeModal: () => void;
  onProceed: () => void;
  policy?: Policy;
};

const ApplyDiscount = ({ closeModal, onProceed, policy }: ApplyDiscountProps) => {
  return (
    <div className=" dark:bg-darkBg">
      <div className="p-[1.5rem]">
        <Formik
          initialValues={{ discountCode: '' }}
          validateOnBlur
          validationSchema={Yup.object().shape({
            discountCode: Yup.string().trim().required('Discount code is required')
          })}
          onSubmit={async (values) => {
            try {
              const { discountCode } = values;
              const policyNumber = policy?.ref;
              if (policyNumber) {
                const response = await applyDiscount(policyNumber, discountCode);

                if (response) {
                 showToast.success(response?.message);
                  closeModal();
                  onProceed();
                }
              }
            } catch (error: IRequestResponse | AxiosError | any) {
              showToast.error(error?.description || error?.message);
            }
          }}>
          {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="mt-[1rem]">
                <Input
                  label="Discount code"
                  type="text"
                  id="discountCode"
                  value={values.discountCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="discountCode"
                  error={touched.discountCode ? errors.discountCode : undefined}
                  helperText={touched.discountCode ? errors.discountCode : undefined}
                  required
                />
              </div>
               <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  type="button"
                  label="Cancel"
                  onClick={closeModal}
                  bgColor="secondary"
                  fullWidth
                />
                <Button
                  type="submit"
                  label="Apply"
                  bgColor="primary"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  fullWidth
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ApplyDiscount;
